import * as MixpanelAudience from '../../react/infra/mixpanel/MixpanelAudience';
import { getDemographicsDataForPreviewBySegment, getSegmentIds } from '../../react/services/AudienceInsightsService';
import { isRequestCancelled } from '../../react/services/AudienceServiceHelper';

module.exports = angular.module(__filename, []).directive('unifiedTvAudiencePreviewWidget', [
  '$state', 'context',
  function ($state, context) {
    return {
      restrict: 'E',
      scope: {
        sources: '=',
        channel: '=',
        onAudienceDataLoaded: '=',
        marketsAndAdvertisersPromise: '=',
        audienceId: '=',
        audienceName: '=',
        audienceSegment: '=',
        isActivateEnabled: '=',
        isActivateVisible: '=',
        isActivateTargetEnabled: '=',
        isActivateAudienceEnabled: '=',
        isActivateAudienceVisible: '=',
        activateAudienceDisabledText: '=',
        getSegmentIds: '=',
        createAudienceTargetTaxonomy: '=',
        createAudienceTargetUserList: '=',
        createAmplifiedAudience: '=',
        createAlwaysOnAudience: '=',
        createDeterministicAudience: '=',
        createUserListForDeterministicAudience: '=',
        createUnifiedTvActivation: '=',
        notificator: '=',
        dspService: '=',
        updateAudienceDeterministicActivated: '=',
        updateAudienceAmplifiedActivated: '=',
        updateAudienceAlwaysOnActivated: '=',
        isAudienceDeterministicActivated: '=',
        isAudienceAmplifiedActivated: '=',
        isAudienceAlwaysOnActivated: '=',
        activatedAmplifiedThreshold: '=',
        activatedAlwaysOnThreshold: '=',
        activatedMarket: '=',
        activatedAdvertiser: '=',
        activatedDataContractId: '=',
        activatedDataContractText: '=',
        activatedCategoryId: '=',
        ssoService: '=',
        getAmplifiedEstimatedReachGoal: '=',
        handleActivatingAudience: '=',
        onUnifiedAudiencesActivated: '=',
        handleActivatingTarget: '=',
        hasAmplificationModeSelector: '=',
        getDataContract: '=',
        getTaxonomyCategory: '=',
        getAmpModelCategory: '=',
        isDeterministicDynamicAllowed: '=',
        isContextualUniquenessError: '=',
        allowDeterministicSegment: '=',
        allowCustomPriceSegment: '=',
        allowOptimizeSegment: '=',
        hideAudiencePreview: '=',
        showAudienceIpCount: '=',
      },
      template: require('./unified-tv-audience-preview-widget.html'),
      link: function ($scope) {
        $scope.audienceDistributionService = getDemographicsDataForPreviewBySegment;
        $scope.householdDistributionService = (audienceSegment, channel, options) =>
          getSegmentIds(audienceSegment, channel, { ...options, isShowHouseholds: true });
        $scope.isRequestCancelledService = isRequestCancelled;
        $scope.userId = context.current.u_id;

        this.context = context;

        $scope.exploreAudience = function () {
          context.current.audience_segment_target_ratio = null;
          MixpanelAudience.trackExploreAudience({
            channel: $scope.channel,
            segment: (context.current.audience_app || {})[$scope.channel],
          });
          $state.go('audience-explorer');
        };

        $scope.trackTooNarrow = () => {
          const snapshot = angular.copy(this.context.current);
          MixpanelAudience.trackTooNarrow(snapshot);
        };
      },
    };
  },
]);
